import React, { useEffect, useState } from "react";
import "~/assets/sass/pages/round/external/external.scss";
import logoImg from "~/assets/img/logo-black.svg";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import { loginExternal } from "~/store/external/actions";

const LoginContainer = () => {
	const navigate = useNavigate();
	const loginForm = useForm();
	const params = useParams();
	const [, dispatch] = useGlobalStore();
	const loginRequest = useRequest("post", "/vc/round/external/login");
	const defaultRequest = useRequest("get", "/vc/round/external/default");
	const [info, setInfo] = useState();

	useEffect(() => {
		defaultRequest.singleCall(params.idx, "path");
	});

	useEffect(() => {
		switch (defaultRequest.state) {
			case API_STATE.done:
				setInfo(defaultRequest.response.data);
				break;
			case API_STATE.error:
				console.log("loginRequest.error >>> ", defaultRequest.error);
				break;
			default:
				break;
		}
	}, [defaultRequest.state, defaultRequest.error, defaultRequest.response]);

	const handleLogin = (data) => {
		loginRequest.call({
			roundIdx: parseInt(params.idx),
			id: data.id,
			pw: data.pw,
		});
	};

	useEffect(() => {
		switch (loginRequest.state) {
			case API_STATE.done:
				dispatch(
					loginExternal({
						accessToken: loginRequest.response.data.judge.token,
						userNm: loginRequest.response.data.judge.name,
						status: info?.status,
					})
				);
				// dispatch(blockUrlChange({ targetIdx: params.idx }));
				navigate(`/externalRoundDetail/${params.idx}`);
				break;
			case API_STATE.error:
				alert("등록되지 않은 계정입니다.");
				console.log("loginRequest.error >>> ", loginRequest.error);
				break;
			default:
				break;
		}
	}, [loginRequest.state, loginRequest.error, loginRequest.response]);

	// irBasicInfo?.regDate.substring(0,10)
	return (
		<div className="l__dashboard">
			<div className="external-login">
				<div className="c__card external-login-card">
					<div className="external-login-top">
						<p className="login-top-msg">GITBAL ROUND EVENT</p>
						<p className="login-top-title">{info?.title}</p>
						<p className="login-top-date">
							{info?.startDate.substring(0, 10)} ~ {info?.endDate.substring(0, 10)}
						</p>
					</div>
					<div className="external-login-bottom">
						<h1 className="logo">
							<a
								href={"https://gitbal.io"}
								target={"_blank"}
								rel="noopener noreferrer"
							>
								<img src={logoImg} alt="logo" />
							</a>
						</h1>
						<div className="external-login-container">
							<Form useForm={loginForm} className="external-login-form vertical">
								<Input
									placeholder="아이디"
									name="id"
									type="email"
									validation={{ required: "아이디를 입력해주세요" }}
									required
								/>
								<Input
									placeholder="비밀번호"
									name="pw"
									type="password"
									validation={{ required: "비밀번호를 입력해주세요" }}
									required
								/>
								<div className="login-form-bottom">
									<button
										type="button"
										className="btn__solid login-btn"
										color="primary"
										onClick={loginForm.handleSubmit(handleLogin)}
									>
										로그인
									</button>
								</div>
							</Form>

							{/*-------------------- 심사기간 끝 & 심사 마감*/}
							{/*<div className="external-login-content">*/}
							{/*심사기간이 아닐 때*/}
							{/*<h4 className="content">심사기간이 아닙니다.</h4>*/}

							{/*심사 마감일 때*/}
							{/*	<h4 className="content end">마감되었습니다.</h4>*/}
							{/*	<p className="content-desc">참여해주신 모든 분들께 진심으로 감사드립니다!</p>*/}
							{/*</div>*/}
						</div>
						<div className="external-login-notice">
							<p className="gitbal-explain">
								스타트업과 투자자를 연결하는 [깃발] 플랫폼에서는 스타트업의 성장을
								위해 다양한 서비스를 제공하고 있습니다. 지금 바로 경험하세요.
								<a
									href={"https://gitbal.io"}
									className="btn-link"
									target={"_blank"}
								>
									깃발 바로가기
								</a>
							</p>
						</div>
					</div>
				</div>
				{/*<div className="policy-btn">*/}
				{/*	<button className="btn-ghost">*/}
				{/*		<Link to={"../user/policy/privacy"} target="_blank">*/}
				{/*			이용약관*/}
				{/*		</Link>*/}
				{/*	</button>*/}
				{/*	<button className="btn-ghost">*/}
				{/*		<Link to={"../user/policy/terms"} target="_blank">*/}
				{/*			개인정보처리방침*/}
				{/*		</Link>*/}
				{/*	</button>*/}
				{/*</div>*/}
			</div>
		</div>
	);
};

export default LoginContainer;
